export default __webpack_public_path__ + "assets/images/image_events.e7d24b37.png";